import { __assign, __rest } from "tslib";
import React from "react";
import { TouchableOpacity, Text, View, Platform } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacRowHeader.styles.js";
import { textStyle } from "../v2/theme";
import PnmacImage from '../Image';
var PnmacSpecialRowHeader = function (_a) {
  var secondFunc = _a.secondFunc,
    onClickExpand = _a.onClickExpand,
    rowHeaderContainerStyles = _a.rowHeaderContainerStyles,
    rowHeaderStyles = _a.rowHeaderStyles,
    item = _a.item,
    iconSpacing = _a.iconSpacing,
    Component = _a.renderChildren,
    isExpand = _a.isExpand,
    iconColor = _a.iconColor,
    rowTitleFlex = _a.rowTitleFlex,
    rest = __rest(_a, ["secondFunc", "onClickExpand", "rowHeaderContainerStyles", "rowHeaderStyles", "item", "iconSpacing", "renderChildren", "isExpand", "iconColor", "rowTitleFlex"]);
  var iconDownSVG;
  if (Platform.OS === 'web') {
    if (iconColor === 'blue') {
      iconDownSVG = require("../assets/chevron-down-blue.svg");
    } else {
      iconDownSVG = require("../assets/chevron-down.svg");
    }
  } else {
    if (iconColor === 'blue') {
      iconDownSVG = 'chevronDownBlue';
    } else {
      iconDownSVG = 'chevronDown';
    }
  }
  var iconUpSVG;
  if (Platform.OS === 'web') {
    if (iconColor === 'blue') {
      iconUpSVG = require("../assets/chevron-up-blue.svg");
    } else {
      iconUpSVG = require("../assets/chevron-up.svg");
    }
  } else {
    if (iconColor === 'blue') {
      iconUpSVG = 'chevronUpBlue';
    } else {
      iconUpSVG = 'chevronUp';
    }
  }
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function () {
      if (onClickExpand) {
        onClickExpand(item);
      }
      secondFunc ? secondFunc() : null;
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: __assign(__assign({}, styles.rowHeaderContainerStyles), rowHeaderContainerStyles),
    testID: "rowHeader",
    nativeID: rest.idTag1
  }, !Component ? (/*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row"
    },
    nativeID: rest.idTag2
  }, /*#__PURE__*/React.createElement(View, null, Platform.OS === 'web' ? /*#__PURE__*/React.createElement(Text, {
    style: __assign(__assign({}, textStyle.formTitleSection), rowHeaderStyles),
    nativeID: rest.idTag3
  }, item) : typeof item === 'string' ? /*#__PURE__*/React.createElement(Text, {
    style: __assign(__assign({}, textStyle.formTitleSection), rowHeaderStyles),
    nativeID: rest.idTag3
  }, item) : item), /*#__PURE__*/React.createElement(Text, null, "    "), /*#__PURE__*/React.createElement(View, {
    nativeID: rest.idTag4
  }, isExpand ? PnmacImage(iconUpSVG, 20, item + " chevron Down", 'xml') : PnmacImage(iconDownSVG, 20, item + "chevron up", 'xml')))) : (/*#__PURE__*/React.createElement(Component, {
    nativeID: rest.idTag5
  }))));
};
PnmacSpecialRowHeader.propTypes = {
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  rowHeaderStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  renderChildren: PropTypes.func,
  onClickExpand: PropTypes.func,
  rowHeaderContainerStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};
export default PnmacSpecialRowHeader;